import { render } from "./ShowConjunctionsInfo.vue?vue&type=template&id=0aba45bc&scoped=true"
import script from "./ShowConjunctionsInfo.vue?vue&type=script&lang=js"
export * from "./ShowConjunctionsInfo.vue?vue&type=script&lang=js"

import "./ShowConjunctionsInfo.vue?vue&type=style&index=0&id=0aba45bc&scoped=true&lang=css"

import exportComponent from "/codebuild/output/src2784445594/src/vedicastrochart-vuejs/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0aba45bc"]])

export default __exports__